jQuery('.input-group-prepend').click(function(){
  jQuery(this).closest('form').submit();
});
